import React from 'react';
import { FormattedMessage } from 'react-intl';
import { getYearWithMonth } from '../../../../common/helpers/dateHelper';
import CustomBadge from '../../../../components/CustomBadge';
import { ReferenceType } from '../../../../common/enums/ReferenceType';
import { IFormattedMessage } from '../../../../common/models/common/IFormattedMessage';
import { ReactComponent as Check } from '../../../../assets/icons/check.svg';
import styles from './styles.module.scss';
import { SurveyStatus } from '../../../../common/enums/SurveyStatus';

export const referenceWorkDates = (start: Date, finish: Date | null) => {
  if (!finish) {
    return (
      <FormattedMessage
        id="present"
        defaultMessage="Present"
      >
        {mes => `${getYearWithMonth(start)} - ${mes}`}
      </FormattedMessage>
    );
  }
  return `${getYearWithMonth(start)} - ${getYearWithMonth(finish)}`;
};

export const badge = (status?: SurveyStatus) => (status === SurveyStatus.Finished ? (
  <CustomBadge min={0} value={1} max={0}>
    <div className="d-flex align-items-center">
      <Check className={styles.checkIcon} />
      <FormattedMessage id="responded" defaultMessage="Complete" />
    </div>
  </CustomBadge>
)
  : (
    <CustomBadge min={1} value={0} max={1}>
      <FormattedMessage id="notResponded" defaultMessage="Incomplete" />
    </CustomBadge>
  ));

export const messages: Record<ReferenceType, IFormattedMessage> = {
  [ReferenceType.Manager]: { id: 'review.managersCount.one', defaultMessage: 'Manager' },
  [ReferenceType.Peer]: { id: 'review.peersCount.one', defaultMessage: 'Peer / Colleague' },
  [ReferenceType.Subordinate]: { id: 'review.subordinatesCount.one', defaultMessage: 'Subordinate' },
  [ReferenceType.Educator]: { id: 'review.educatorsCount.one', defaultMessage: 'Educator' },
  [ReferenceType.Other]: { id: 'review.othersCount.one', defaultMessage: 'Other' }
};
